module.exports = __webpack_public_path__ + "img/profile.473f5971.jpg";